import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { Observable } from "rxjs";
import { ResponseFindAttWorkLocationDto } from "../dto/att-work-location.dto";

@Injectable()
export class AttWorkLocationApi {
  private service: string = '';
  private model: string = 'attWorkLocation';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {
  }
  public findAttWorkLocation(): Observable<ResponseFindAttWorkLocationDto> {
    const method: string = 'GET';
    const func: string = 'findAttWorkLocation';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<ResponseFindAttWorkLocationDto>(method, url, func, params, body, null, null, null, false);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/att-work-location.api.ts